import { isPlainObject } from "lodash";
function useConfigWithExtraValidation(config, getError) {
  let validate;
  if (config == null ? void 0 : config.validate) {
    if (isPlainObject(config.validate)) {
      validate = {
        ...config.validate,
        getError
      };
    } else {
      validate = (value) => getError(value) || config.validate(value);
    }
  } else {
    validate = getError;
  }
  const updatedConfig = {
    ...config,
    validate
  };
  return updatedConfig;
}
export {
  useConfigWithExtraValidation as default
};
